import {
  START_TICKET_TIMER,
  STOP_TICKET_TIMER,
  RESET_TICKET_TIMER,
  SET_LOGOUT_AUTH
} from '../actions/Index';
interface TickerTimerState {
  startTime: number | null;
  stopTime: number | null;
  ticketId: number | null;
  isTicketTimerRunning: boolean;
  patientId: number | null;
  logId: number | null;
}
const initialTicketTimerState: TickerTimerState = {
  startTime: null,
  stopTime: null,
  isTicketTimerRunning: false,
  patientId: null,
  ticketId: null,
  logId: null
};

export const TicketTimerReducer = (
  state = initialTicketTimerState,
  action: any
): TickerTimerState => {
  switch (action.type) {
    case START_TICKET_TIMER:
      return {
        ...state,
        startTime: action.payload.startTime,
        isTicketTimerRunning: true,
        ticketId: action.payload.ticketId,
        patientId: action.payload.patientId,
        logId: action.payload.logId
      };
    case STOP_TICKET_TIMER:
      return {
        ...state,
        stopTime: action.payload.stopTime,
        isTicketTimerRunning: action.payload.stopTimer
          ? action.payload.stopTimer
          : state.isTicketTimerRunning
      };
    case RESET_TICKET_TIMER:
    case SET_LOGOUT_AUTH:
      return initialTicketTimerState;
    default:
      return state;
  }
};
